import styled from 'styled-components'

export const ViewerContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
`

export const ImageContainer = styled.div<{
  $opacity?: number
  $width?: string
  $height?: string
}>`
  position: relative;
  display: inline-block;
  max-width: 100%;
  max-height: 100%;
  opacity: ${({ $opacity }) => $opacity ?? 1};
  width: ${({ $width }) => $width ?? 'auto'};
  height: ${({ $height }) => $height ?? 'auto'};
`

export const MultipageImageContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
`

export const StyledImage = styled.img`
  display: block;
  user-select: none;
  pointer-events: none;
`

export const OverlaySvg = styled.svg`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: visible;
  pointer-events: auto;
`

export const Tooltip = styled.div.attrs<{
  $left: number
  $top: number
  $transform: string
  $noPadding?: boolean
}>((props) => ({
  style: {
    left: `${props.$left}px`,
    top: `${props.$top}px`,
    transform: props.$transform,
  },
}))<{
  $left: number
  $top: number
  $transform: string
  $noPadding?: boolean
}>`
  pointer-events: none;
  position: absolute;
  background-color: ${(props) => props.theme.forecast.cardBackground};
  backdrop-filter: blur(0.25rem);
  box-shadow:
    0 0.125rem 0.375rem 0 ${(props) => props.theme.forecast.boxShadow},
    0 0.0625rem 0.125rem 0 ${(props) => props.theme.forecast.boxShadow};
  border-radius: 0.375rem;
  padding: ${(props) => (props.$noPadding ? '0' : '0.625rem 0.875rem')};
  font-size: 0.8125rem;
  color: ${(props) => props.theme.forecast.defaultText};
  border: 0.0625rem solid ${(props) => props.theme.forecast.border};
  z-index: 1000;
  max-width: 20rem;
`

export const TooltipLabel = styled.div`
  font-weight: 500;
  margin-bottom: 0.25rem;
  color: ${(props) => props.theme.forecast.defaultText};
`

export const TooltipType = styled.div`
  font-size: 0.75rem;
  color: ${(props) => props.theme.forecast.secondaryText};
`
